import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Panel from '../../../shared/components/card/Panel';
import PageHeader from '../../../shared/components/pageHeader/PageHeader';
import { GRIEVANCE_ACTIONS, GRIEVANCE_RAISE_LIST_ROUTE } from '../../../shared/constants/commonConstants';
import { Payer } from '../../../shared/models/payer.model';
import { RootState } from '../../../store';
import { raiseOrUpdateGrievance } from '../../../store/actions/grievanceAction';
import { GrievanceModel } from '../../../store/models/grievanceModel';
import { base64UrlDecode, centeredNotification } from '../../../utils/utility';
import { prepareEmail } from '../services/grievanceConstants';
import EditorResponse from './EditorResponse';
import { fetchGrievanceType } from '../../../store/actions/lookUpAction';
import {
  payerLookUpNamesForGrievanceType,
} from '../../../shared/constants/crmConstants';

const NewGrievance = ({ match }: any): any => {
  const { params: { id } } = match;
  const dispatch = useDispatch();
  const history = useHistory();
  const [emailData, setEmailData] = useState({ subject: '', body: '' });
  const payer = useSelector((state: RootState): Payer => state?.payerList?.payer);
  const [isLoading, setIsLoading] = useState(false);
  const { selectedClaimsList } = useSelector((state: RootState): GrievanceModel => state?.grievance || {});
  const selectedHosActions = base64UrlDecode(id).split('-');
  const selectedClaims = selectedHosActions?.map((hospActionId: string): any => selectedClaimsList?.[hospActionId]);
  const [selectedGrievance, setSelectedGrievance] = useState<any>(null);
  const selectedClaimData = selectedClaims?.[0];

  useEffect((): any => {
    if (id) {
      try {
        if (!Object.keys(selectedClaimsList || {}).length) {
          return history.push(GRIEVANCE_RAISE_LIST_ROUTE);
        }
        const data = prepareEmail(selectedClaims, payer, selectedGrievance);
        setEmailData(data);
      } catch (e) {
        history.push(GRIEVANCE_RAISE_LIST_ROUTE);
      }
    } else {
      history.push(GRIEVANCE_RAISE_LIST_ROUTE);
    }
  }, [selectedGrievance]);

  useEffect((): any => {
    const payerLookUpReqObj = {
      getByPayerId: true,
      getByMasterType: true,
      payerIds: [selectedClaimData?.payerId],
      masterTypes: [...payerLookUpNamesForGrievanceType],
      isDicFormat: true,
      getByProductCode: selectedClaimData?.productCode ? true : false,
      getByBoth: selectedClaimData?.productCode ? true : false,
      productCode: selectedClaimData?.productCode ? [selectedClaimData?.productCode] : [],
    };
    if (selectedClaimData?.hospActionId) {
      dispatch(fetchGrievanceType(payerLookUpReqObj));
    }
  }, []);

  const onSubmitNewGrievance = (data: any): any => {
    const selectedGrievanceItem = data?.selectedClaims?.[0];
    const uploadedFiles = data?.fileList
      ?.map((file: any): any => ({
        fileName: file?.response?.uploadedDetails?.[0]?.fileName,
        fileGuid: file?.response?.uploadedDetails?.[0]?.fileGuid,
      }))
      .filter((fileDetails: any): any => fileDetails.fileName && fileDetails.fileGuid);

      setIsLoading(true);
    const grievanceDetails = {
      ticketId: selectedGrievanceItem?.grievanceTicketId,
      hospactionId: selectedGrievanceItem?.hospActionId,
      payerId: selectedGrievanceItem?.payerId,
      productCode: selectedGrievanceItem?.productCode,
      payerClaimNo: selectedGrievanceItem?.payerClaimNo,
      patientName: selectedGrievanceItem?.patientName,
      action: selectedGrievanceItem?.grievanceTicketId ? null : 115,
      reason: selectedGrievance,
      remarks: data?.remarks,
      attachments: uploadedFiles,
    };
    dispatch(raiseOrUpdateGrievance(grievanceDetails, onSuccess, onError));
  };

  const onSuccess = (): any => {
    setIsLoading(false);
    centeredNotification('Ticket created successfully', 'success');
    history.push(GRIEVANCE_RAISE_LIST_ROUTE);
  };
  const onError = (errMsg: string): any => {
    setIsLoading(false);
    centeredNotification(errMsg);
  };

  return (
    <div className="raise-grievance">
      <PageHeader
        pageTitle={GRIEVANCE_ACTIONS.NEW_GRIEVANCE}
        backUrl={GRIEVANCE_RAISE_LIST_ROUTE}
        isGrievance={true}
      />
      <Panel className="editor-container">
        <EditorResponse
          onSubmit={onSubmitNewGrievance}
          payerEmailId={payer?.emailAddress || ''}
          subject={emailData?.subject || ''}
          emailBody={emailData?.body || ''}
          isLoading={isLoading}
          ticketId={selectedClaimData?.grievanceTicketId}
          setSelectedGrievance={setSelectedGrievance}
          selectedGrievance={selectedGrievance}
          id={id}
        />
      </Panel>
    </div>
  );
};
export default NewGrievance;
